import { useMemo, useState, useEffect } from 'react';
import { getNoNameFiltersData } from '@/pages/intelligence/services/filter';
import { handleRegionsCountriesData2Standard } from '@/pages/intelligence/utils/regionSelectUtils';
import type { IRegion, IGameType } from '@/pages/intelligence/types/common';
import {
  nintendoRegionsOptions,
  nintendoUSRegionsOptions,
  nintendoRegionsOptionsNoGlobal,
} from '@/pages/intelligence/_config/storeRank/console';

export default function usePlatformRegionsOptions(
  platform: string,
  cfg: {
    // 是否需要执行，即调接口 获取 国家列表数据，因为有的公共页面，A、B、C三个公共页面，其中A、B需要国家列表数，但是C页面不需要，就可以通过executable来控制 是否需要调接口
    executable?: boolean;
    entityType: IGameType;
    platforms: string[];
  },
  isNintendoNoGlobal = false,
) {
  const { executable = true, entityType, platforms } = cfg ?? {};

  const [isLoading, setIsLoading] = useState(true);

  const [regionsOptionsMap, setRegionsOptionsMap] = useState<{ [key: string]: IRegion[] }>({});

  const regionsOptions = useMemo<IRegion[]>(
    () => regionsOptionsMap?.[platform] ?? [],
    [platform, regionsOptionsMap],
  );

  const updateRegionsOptionsMap = async () => {
    try {
      const res = await getNoNameFiltersData({
        type: [{ tabName: entityType }],
        multiitem: platforms,
      });
      const platformRegionsCountries = res?.data?.platform_region_country;
      if (!Array.isArray(platformRegionsCountries)) {
        setRegionsOptionsMap({});
        return;
      }
      const regionsOptionsMapTmp: {
        [key: string]: IRegion[];
      } = {};
      platformRegionsCountries.forEach((item: any) => {
        const itemName = item?.name;
        if (!itemName) return;
        regionsOptionsMapTmp[itemName] = handleRegionsCountriesData2Standard(item?.region_country);
      });
      regionsOptionsMapTmp.nintendo = isNintendoNoGlobal
        ? nintendoRegionsOptionsNoGlobal
        : nintendoRegionsOptions;
      regionsOptionsMapTmp.nintendoUsOnly = nintendoUSRegionsOptions;
      setRegionsOptionsMap(regionsOptionsMapTmp);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!executable) return;
    updateRegionsOptionsMap();
  }, []);

  return {
    isLoading,
    regionsOptions,
    regionsOptionsMap,
  };
}
